import GlobalSearch from './GlobalSearch'
export default GlobalSearch



// WEBPACK FOOTER //
// ./src/Components/FixedGlobalSearch/GlobalSearch/index.js